<template>
	<div class="px-4 sm:px-6 lg:px-6 pt-6 bg-gray-100 flex-grow flex flex-col">
		<div class="grid md:grid-cols-2 gap-x-6 gap-y-6">
			<div>
				<h3 class="text-2xl font-semibold text-gray-700 mb-6">
					{{ __("dashboard_empty_info_overview_title") }}
				</h3>
				<p>{{ __("dashboard_empty_info_overview_text") }}</p>
			</div>

			<div>
				<h3 class="text-2xl font-semibold text-gray-700 mb-6">
					{{ __("dashboard_empty_info_title") }}
				</h3>
				<p>
					{{ __("dashboard_empty_info_text_1") }} <br />{{
						__("dashboard_empty_info_text_2")
					}}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>
